import { Const } from '../lib/const.cls'

export const getters = {
	[Const.GET_DASHBOARD_LINK1]: (state) => { return state.dashboardLink1 },
	[Const.GET_DASHBOARD_LINK2]: (state) => { return state.dashboardLink2 },

	[Const.GET_DASHBOARD_CHART_DATA]: (state) => { return state.ChartData },
	//support
	[Const.GET_TICKET_DATA]: (state) => { return state.ticketData },
	[Const.GET_TICKET_LIST]: (state) => { return state.ticketList },
	[Const.GET_TICKET_VIEW]: (state) => { return state.ticketView },
	[Const.GET_TICKET_REASON_LIST]: (state) => { return state.ticketReasonList },
	[Const.GET_REASON_LIST]: (state) => { return state.reasonList },


	[Const.GET_USER_PROFILE]: (state) => { return state.userProfile },
	[Const.GET_COUNTRIES_LIST]: (state) => { return state.countriesList },
	[Const.GET_CITIES_LIST]: (state) => { return state.citiesList },
	[Const.GET_DASHBOARD_DATA]: (state) => { return state.dashboardData },

	//ib
	[Const.GET_IB_LIST]: (state) => { return state.ibList },
	[Const.GET_IB_DETAIL]: (state) => { return state.ibDetail },

	//client
	[Const.GET_TRADING_ACCOUNT_DETAIL]: (state) => { return state.tradAccountDetail },

	[Const.GET_USER_LIST]: (state) => { return state.userList },
	[Const.GET_USER_VIEW]: (state) => { return state.userView },
	[Const.GET_USER_COUNT]: (state) => { return state.userCount },

	//deposit
	[Const.GET_DEPOSIT_LIST]: (state) => { return state.depositList },
	[Const.GET_DEPOSIT_VIEW]: (state) => { return state.depositView },

	//bonus
	[Const.GET_BONUS_LIST]: (state) => { return state.bonusList },
	[Const.GET_BONUS_VIEW]: (state) => { return state.bonusView },

	//withdrawal
	[Const.GET_WITHDRAWAL_LIST]: (state) => { return state.withdrawalList },
	[Const.GET_WITHDRAWAL_COMMISSION_LIST]: (state) => { return state.withdrawalCommList },
	[Const.GET_AFFILIATE_EARNINGS]: (state) => { return state.affiliateCommList },
	[Const.GET_WITHDRAWAL_VIEW]: (state) => { return state.withdrawalView },
	[Const.GET_WITHDRAWAL_METHOD_RESPONSE]: (state) => { return state.withdrawalMethodResponse },
	[Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP]: (state) => { return state.withdrawalMethodResponseDep },

	[Const.GET_WITHDRAWAL_METHOD]: (state) => { return state.withdrawalMethod },

	//trading
	[Const.GET_TRADING_LIST]: (state) => { return state.tradingList },
	[Const.GET_IB_TRADING_LIST]: (state) => { return state.ibtradingList.records ? state.ibtradingList.records : [] },
	[Const.GET_TRADING_VIEW]: (state) => { return state.tradingView },

	//static
	[Const.GET_DEPARMENT_LIST]: (state) => { return state.department_list },
	[Const.GET_TICKET_DOCS_LINK]: (state) => { return state.ticketDocsLink },
	[Const.GET_EMP_STATUS]: (state) => { return state.empStatus },
	[Const.GET_OCCUPATION]: (state) => { return state.occupation },
	[Const.GET_EST_YEARLY_INCOME]: (state) => { return state.estYearlyIncome },
	[Const.GET_EST_NET_WORTH]: (state) => { return state.estNetWorth },
	[Const.GET_ACCOUNT_TURNOVER]: (state) => { return state.antAccountTurnover },
	[Const.GET_GENDER_LIST]: (state) => { return state.genderList },
	[Const.GET_STEP]: (state) => { return state.stepsText },
	[Const.GET_DEPOSIT_METHOD]: (state) => { return state.depositMethod },
	[Const.GET_DEPOSIT_STATUS]: (state) => { return state.depositStatus },
	[Const.GET_WITHDRAWAL_TYPE]: (state) => { return state.withdrawalType },
	[Const.GET_WITHDRAWAL_METHODS]: (state) => { return state.withdrawalMethods },
	[Const.GET_WITHDRAWAL_STATUS]: (state) => { return state.withdrawalStatus },
	[Const.GET_CURRENCY]: (state) => { return state.currency },
	[Const.GET_DEMO_LIVE]: (state) => { return state.demoLive },
	[Const.GET_PRO_USERS]: (state) => { return state.proUsers },
	[Const.GET_BONUS_TYPE]: (state) => { return state.bonusType },
	[Const.GET_BONUS_STATUS]: (state) => { return state.bonusStatus },

	// user sub ib list
	[Const.GET_USER_SUBIB_LIST]: (state) => { return state.subIbList },

	[Const.GET_TRADING_ACCOUNT_LIST]: (state) => { return state.tradingAccountList },
	[Const.GET_USER_COMMISSION]: (state) => { return state.userCommission },

	//withdrawal method list
	[Const.GET_SKRILL_ID]: (state) => { return state.skrill_id_data },
	[Const.GET_NETELLER_ID]: (state) => { return state.neteller_id_data },
	[Const.GET_CRYPTO_ID_LIST]: (state) => { return state.crypto_id_list },

}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/getters.js